import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../../hoc/Loading/Loading';
import axios from '../../../axios';
import {groupContentFields,groupPrivacyStatusDesc, groupERGcategories, profilePicValidityCheck} from '../../../utils/constants';
import * as actionCreators from '../../../modules/actions/index';
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import Select, {StylesConfig} from "react-select";
import { ModalBody } from 'reactstrap';
import GrpBannerImgModal from './GrpBannerModal';

class GroupSettings extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      name:this.props.group.name,
      privacy:this.props.group.privacy,
      invitedUsers:[],
      users:[],
      searchedUser:'',
      removeUsers:[],
      description:this.props.group.description,
      selectedCategories:this.props.group.categories,
      groupCategories:groupERGcategories,
      isDescErr:false
     }
     this.timer=null;
  }


changeGroupName=(event)=>{
  let{name}=this.state
  const { value } = event.target;
  let obj = {name:value}
  if(name.length<75){
    this.setState(obj)
    this.props.changeGroupName(obj)
  } 
  // else {
  //   this.setState
  // }
}

changePrivacy=(value)=>{
  if(value){
    let id = typeof(value)=='object'?value.id: value
    this.setState({privacy:id})
    this.props.changePrivacy({privacy:id})
  }
}


assignedUserDelay = ({ target })=>{
  const { value } = target;  
  this.setState({ searchedUser: value })
  clearTimeout(this.timer);
  this.timer = setTimeout(() => {
    this.handleAssignUser(value);
  }, 1000);
 
}

handleAssignUser = value => {
  if(value && value.length>0){
    let payload = {
      name:value,
      removeUsers: this.state.removeUsers,
      noLoader: true
    }

    axios.post(url.searchUsers, payload).then( (resp,idx) =>{
      let users = resp.data.data

      if(users.length==0){
        users='No users were found'
      }

      this.setState({users})
    })
  } else {
    this.setState({users:[]})
  }

}

assignedUserFormat=selectedUser=>{
  let{removeUsers}=this.state
  // let obj = {
  //   fullName: `${selectedUser.firstName} ${selectedUser.lastName}`,
  //   user: selectedUser
  // }
  if(removeUsers.indexOf(selectedUser._id)==-1 || removeUsers.length==0){
    let userId = selectedUser._id
    let organizationId = selectedUser.organizationId
    // delete selectedUser._id
    // delete selectedUser.organizationId
    let u = {
      email:selectedUser.email,
      profilePic: selectedUser.profilePic,
      firstName:selectedUser.firstName,
      lastName:selectedUser.lastName,
      userId, 
      role: {value : 1000, label : 'Member'},
      organizationId, 
      dateJoined: new Date()}
    let invitedUsers = this.state.invitedUsers.concat(u)


    this.setState(prevState=>({
      invitedUsers,
      removeUsers: prevState.removeUsers.concat(selectedUser._id), 
      users: [],
      searchedUser:''
    }))
    this.props.handleInvitedUsers(invitedUsers.length)
  }
}


getInitials=(user)=>{
  let firstName = user.firstName &&user.firstName.length>0?user.firstName:'N'
  let lastName = user.lastName &&user.lastName.length>0?user.lastName:'N'
  return firstName.charAt(0).toUpperCase()+ lastName.charAt(0).toUpperCase() 
}


createGroup=()=>{
  let{name, privacy, invitedUsers,selectedCategories,description}=this.state
  let{bannerImg, user}=this.props
  // let userId =  user.profile._id
  // delete this.props.user.profile._id
  let current_u = {
     email: user.profile.email,
    //  role: {value : 0, label : 'Admin'},
    role:0,
      profilePic: user.profile.profilePic,
      firstName: user.profile.firstName,
      lastName: user.profile.lastName,
      userId: this.props.user.profile._id, 
      organizationId: user.profile.organizationId._id, 
      dateJoined: new Date() }
  
  invitedUsers = invitedUsers.concat(current_u)
  
  let payload = {
    name, privacy, members:invitedUsers,bannerImg,
    categories:selectedCategories, description
  }
  let that=this

  const formData = new FormData();

  formData.append('payload', JSON.stringify(payload))
  formData.append('uploads', bannerImg.file);

  axios.post(url.createGroup, formData).then(({ data }) => {
    let groupId = data.data._id
    let url =`/home/groups/${user.profile.organizationId._id}/view/${groupId}`
    that.props.history.push({pathname : url });
  }).catch((error) => {
    console.log(error);
  }) 
}


removeUser = user =>{
  let{invitedUsers}=this.state 
  invitedUsers = invitedUsers.filter(e=> e.userId!=user.userId)
  this.setState({ invitedUsers })
}

handleKeyPress = (e) => {
  if (e.key === 'Enter') {
    // this.handleSubmitTodo();
    // e.preventDefault()
  }
}

handleGrpDesc = ({target}) => {
  let{description}=this.state
  const {value} = target;
  description=value
  if(description.length>200){
    this.setState({description: description.slice(0, 200), isDescErr:true})
  }
  this.setState({
    description : value
  })
  this.props.handleGrpDesc(value)
}

addGroupCategory=selectedCategories=>{
  let res = selectedCategories.map(e=>e.id)
  groupERGcategories.filter(e=> res.indexOf(e.id)==-1)
  this.setState({
    selectedCategories,
    groupCategories:groupERGcategories
  })
}

goBack = () =>{
  this.props.history.push(`/home/groups/${this.props.user.profile.organizationId._id}`)
}

  render() {
    let{name,privacy,invitedUsers,users, searchedUser,
      groupCategories,selectedCategories,isDescErr,
      description}=this.state
    let{user,bannerImg}=this.props
    console.log('bannerImg: ', bannerImg)
    let isCreate = name!=''&privacy!=null?true:false
    // console.log('invitedUsers: ', invitedUsers)
    return (
      <span>
            <div className="floating-label-group">
              <input type="text" id="name" className="form-control"
                  onChange={this.changeGroupName} 
                  value={name}  placeholder=" "
                  autoComplete="off" />
              <label className="floating-label"> Name {name.length>0?` (${name.length}/75 char)`:'(max 75 char)'} </label>
            </div>

            <div className="floating-label-group"> 
                    <Select name="kpi-select" 
                      placeholder={""} 
                      value={privacy} 
                      // optionRenderer={[{}]}
                      simpleValue
                      isOpen={true}
                      onChange={privacy => this.changePrivacy(privacy)} 
                      options={groupPrivacyStatusDesc} 
                      valueKey="id" labelKey="name" 
                      getOptionLabel={({ name }) => name} getOptionValue={({ id }) => id}
                      />
                  <label className={privacy!=null?'floating_label_invite_user':`floating-label`}> Privacy Status </label>
                  {/* <label className="floating-label">Choose Privacy</label> */}
                </div>

                <div className="floating-label-group grp_invite_user_input_item">
                  {invitedUsers.length>0?
                  <div className="grp_invite_user_input_invited_users_container">
                    { invitedUsers.map((e,idx)=>{
                    return (<span key={e.userId+idx} className="grp_invite_user_input_invited_users">
                                {profilePicValidityCheck(e.profilePic)?
                                    <img className="grp_create_search_user_pic" src={e.profilePic}/>
                                      :
                                    <span className="spotlightUserInitials" data-letters={this.getInitials(e)}></span>
                                }
                          {e.firstName} {e.lastName?e.lastName:''}
                          <i onClick={()=>this.removeUser(e)}
                          className="flaticon-trash"/></span>)
                    })}
                    </div>
                      :
                    null}
                  <input type="text" id="invitedUsers" className="form-control"
                      onChange={this.assignedUserDelay} 
                      value={searchedUser}
                      autoComplete="off"  placeholder=' '/>
                  <label className={invitedUsers.length>0?'floating_label_invite_user':`floating-label`}> Invite members </label>
                  {Array.isArray(users) && users.length>0?
                    <span className="grp_create_search_user_res">
                        <div className="divTable">
                        <div className="divTableBody">
                            
                            {users.map( user => {
                              return (
                                  <div className="divTableRow" onClick={()=>this.assignedUserFormat(user)} key={user._id+user.organizationId}>
                                    <div className="divTableCell">
                                      {profilePicValidityCheck(user.profilePic)?
                                      <img className="grp_create_search_user_pic" src={user.profilePic}/>
                                      :
                                      <span className="spotlightUserInitials" data-letters={this.getInitials(user)}></span>
                                      }
                                      {user.firstName} {user.lastName}
                                    </div>
                                    </div>
                                )
                              })}
                          
                                                          
                          </div>
                        </div>   
                      </span>                   
                      :
                      null
                      }
                </div>

                <div className="floating-label-group"> 
                <textarea
                    className={'grp_create_description_txt'}
                    placeholder=""
                    onKeyPress={this.handleKeyPress}
                    onChange={this.handleGrpDesc}
                    value={description}
                  />
            <label className={description&&description.length>0?'floating_label_invite_user':`floating-label`}>  Description {description.length>0?` (${description.length}/200 char)`:'max 200 char'} (optional)  </label>
            {isDescErr?
                   <div className="grp_create_description_error"> Group description can not exceed 200 characters. </div>:
                   null
                   } 
            </div>

                   
                   




              {/* ------ Choose Group Categories ------*/}

              <div className="floating-label-group grp_create_category_container"> 
                    <Select name="kpi-select" 
                      placeholder={""} 
                      isMulti 
                      value={selectedCategories.length>0?selectedCategories:''} 
                      multi
                      isOpen 
                      onChange={this.addGroupCategory}
                      // onChange={cat => this.addGroupCategory(cat)} 
                      options={groupCategories} 
                      valueKey="id" labelKey="name" 
                      getOptionLabel={({ name }) => name} getOptionValue={({ id }) => id}
                      />
                      <label className={selectedCategories.length>0?'floating_label_invite_user':`floating-label`}>  Group types (optional)</label>

                        {/* <label className="floating-label">Choose Group categories (optional)</label> */}
              </div> 





              <GrpBannerImgModal
        removeBannerImg={this.removeBannerImg} 
        setBannerImg={this.setBannerImg}
        image = {this.state.bannerImg}
        openBannerModal={this.openBannerModal}
        isBannerOpen={this.state.isBannerOpen}/>

        </span>
          
    );
  }
}










const mapStateToProps = state => {
    return {
      user: state.user,
      kpiMaster: state.kpiMaster,
      mappingMaster: state.mappingMaster,
      reports:state.reports
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
      onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
      onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
      updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
      updateReport: (dashboard)=> dispatch(actionCreators.updateReport(dashboard)),
  
    }
  }


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(GroupSettings, axios)));